export class CouponShowCaseModel {
    head = '';
    result = '';
    phrase1 = '';
    phrase2 = '';
    imagePath = '';
    couponCode = '';
    couponCodeSysNo = 0;
    strExpireDate = '';
}
export class ClippedCouponModel {
    SysNo = 0;
    CouponCode = '';
    CouponCodeSysNo = 0;
    CouponCodeVersion = '';
    Result = '';
    StrExpireDate = '';
    MinPurchase = '';
    MaxDiscount = '';
}
export class CouponInfo {
    Head = "";
    Result = "";
    Phrase1 = "";
    Phrase2 = "";
    CouponCode = "";
    Isclipped = false;
    EndDate = '';
    CouponCodeSysNo = 0;
    IsShow = false;
}
export class CouponCodePopupModel {
    couponCode = '';
    headLine = '';
    description = '';
    tips = '';
}
